import { render, staticRenderFns } from "./ReadOnlyCheckBox.vue?vue&type=template&id=283d6495&scoped=true"
import script from "./ReadOnlyCheckBox.vue?vue&type=script&lang=ts"
export * from "./ReadOnlyCheckBox.vue?vue&type=script&lang=ts"
import style0 from "./ReadOnlyCheckBox.vue?vue&type=style&index=0&id=283d6495&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283d6495",
  null
  
)

export default component.exports